import React from "react";

import { Fade } from "react-reveal";

import "./styles.css";

const heroImage = require("../../../../assets/images/campus&university/campusanduniversity.webp");
const Hero = () => {
  return (
    <Fade bottom>
      <div className="rural_hero_container">
        <div className="rural_hero_media_wrap">
          <img
            className="rural_hero_media"
            src={heroImage}
            alt="Public safety command center"
          />
          <div className="rural_hero_text">
            <span className="h4-m text-white rural_hero_kicker">
              The United States Department of Justice Office on Violence Against
              Women Grant Program-aligned
            </span>
            <p className="title-b text-white rural_hero_title">
              <span className="rural_hero_product">See It Send It</span> for
              Campuses & Universities
            </p>
            <p className="h2-m text-white rural_hero_subtitle">
              The United States Department of Justice is offering grants, which
              require no matching funds, to public and private colleges and
              universities to help them enhance the safety and justice for
              victims of sexual assault, stalking, and domestic violence. The
              grants are targeted to campuses and universities located in rural
              states.
            </p>
            <div className="rural_hero_tags">
              <span className="h4-m text-white">Reporting</span>
              <span className="h4-m text-white">Documentation</span>
              <span className="h4-m text-white">Coordination</span>
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default Hero;
